export default __webpack_public_path__ + "static/brightCove-0c5797419a914daed0b43bd8f554e9ae.png";